module.exports = __webpack_public_path__ + "img/demoicon_selected.png";